import React from "react";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { isIntegrationConnection } from "@common/helpers/integrationConnection";
import { useConnectionOwnership } from "@hooks/useConnectionOwnership";

interface Props {
    connection: FinancialConnection | IntegrationConnection;
}

export const DisconnectedConnectionMessage: React.FC<Props> = ({
    connection,
}) => {
    const isOwner = useConnectionOwnership(connection);
    const ownerName = isIntegrationConnection(connection)
        ? connection.createdByUser?.name
        : connection.user?.name;
    const shouldShowOwner = !isOwner && Boolean(ownerName);

    return (
        <>
            <p className="mb-0">This account is disconnected.</p>
            {shouldShowOwner && (
                <p className="mb-0">Connected by {ownerName}.</p>
            )}
        </>
    );
};
